export enum MessageStatusEnum {
	UPLOADING = 1,
	PENDING = 2,
	SENT = 3,
	DELIVERED = 5,
	READ = 6,
	FAILED = 7,
	UPLOAD_FAILED = 8,
	SYSTEM = 9,
	DELETED_FOR_USER = 10,
	DELETED_FOR_EVERYONE = 11,
}
